module.exports = __webpack_public_path__ + "static/img/far3_active.72bdc26b.png";